import { useEffect, useState } from 'react';
import { WBBox } from '@admiin-com/ds-web';
import { t } from 'i18next';
import { generateInvoiceContent } from '../../utils/invoice';
import { BillCreateFormData } from '../../features/providers/TaskCreationProvider/TaskCreationProvider';
import { registerHandlebarsHelpers } from '../../helpers/handlebars';

registerHandlebarsHelpers();

interface Props {
  values: BillCreateFormData;
  brandColor?: string;
  customHtml?: string;
}

const InvoiceRenderer = ({ values, brandColor, customHtml }: Props) => {
  const [compiledHtml, setCompiledHtml] = useState('');

  useEffect(() => {
    generateInvoiceContent(
      {
        ...values,
        lineItems: values.lineItems.map((lineitem) => ({
          ...lineitem,
          taxType: t(lineitem.taxType ?? '', { ns: 'taskbox' }),
        })),
        brandColor,
      },
      customHtml
    ).then((html) => {
      setCompiledHtml(html);
    });
  }, [values, brandColor]);

  return (
    <WBBox
      sx={{
        backgroundColor: 'white',
        color: 'black',
        width: '100%',
      }}
    >
      <WBBox
        sx={{
          p: 2,
          backgroundColor: 'white',
          width: '100%',
          // Add these styles to create style isolation
          '& > div': {
            isolation: 'isolate', // Creates a new stacking context
          },
          // Scope all styles to only affect elements within the invoice
          '& .invoice-root *': {
            all: 'revert', // Reset all properties to their inherited values
          },
        }}
        dangerouslySetInnerHTML={{ __html: compiledHtml }}
      />
    </WBBox>
  );
};

export default InvoiceRenderer;
